export default [
    {
        path: '/plus/otherLogin', // plus登录
        component: resolve => require(['@/pages/plus/otherLogin'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/plus/paySuccess', // 支付成功
        component: resolve => require(['@/pages/plus/paySuccess'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/plus/orderDetail', // 订单详情
        component: resolve => require(['@/pages/plus/orderDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/plus/cardIntro', // puls购买
        component: resolve => require(['@/pages/plus/cardIntro'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/plus/benefitDetail', // puls权益
        component: resolve => require(['@/pages/plus/benefitDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/plus/order', // 订单列表
        component: resolve => require(['@/pages/plus/order'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/plus/ruleInfo', // 规则信息
        component: resolve => require(['@/pages/plus/ruleInfo'], resolve),
        meta: { title: "长龙航空" }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/plus.js